/**
 * @file constants.js
 * @description Configuração da API para CRA
 */

/**
 * @constant API_CONFIG
 * @description Configuração da API
 */
export const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3002/api",
  timeout: 60000,
  defaultHeaders: {
    "Content-Type": "application/json",
  },
}

/**
 * @constant ERROR_MESSAGES
 * @description Mensagens de erro padronizadas
 */
export const ERROR_MESSAGES = {
  NETWORK_ERROR: "Erro de conexão. Verifique sua internet.",
  VALIDATION_ERROR: "Dados inválidos",
  UNAUTHORIZED: "Sessão expirou. Faça login novamente.",
  FORBIDDEN: "Acesso negado",
  NOT_FOUND: "Recurso não encontrado",
  SERVER_ERROR: "Erro no servidor. Tente novamente mais tarde.",
  UNKNOWN_ERROR: "Ocorreu um erro inesperado",
}

/**
 * @constant ERROR_CODES
 * @description Códigos de erro padronizados
 */
export const ERROR_CODES = {
  NETWORK_ERROR: "NETWORK_ERROR",
  VALIDATION_ERROR: "VALIDATION_ERROR",
  UNAUTHORIZED: "UNAUTHORIZED",
  FORBIDDEN: "FORBIDDEN",
  NOT_FOUND: "NOT_FOUND",
  SERVER_ERROR: "SERVER_ERROR",
  UNKNOWN_ERROR: "UNKNOWN_ERROR",
}
